/* eslint-disable no-console, no-underscore-dangle */
import { options } from 'preact';

/**
 * Global safety net for uncaught Preact component errors.
 *
 * Every component error (render, useEffect, commit callbacks) goes through
 * options._catchError, which rethrows when no error boundary handles it.
 * Inside Preact's shared useEffect flush, that rethrow aborts the queue and
 * every later useEffect on the page never runs (size guide, mini cart,
 * lazy images, ATC price...). Log the error instead so the rest of the page
 * keeps working and FullStory still captures it.
 *
 * `__e` is Preact 10's minified name for options._catchError (stable across
 * 10.x, preact/debug and preact/compat rely on it). Revisit on Preact 11.
 *
 * Must be imported first in the store entry points (laura.main.js,
 * melanielyne.main.js).
 */
const previous = options.__e;

if (typeof previous === 'function') {
  options.__e = (error, vnode, oldVNode, errorInfo) => {
    try {
      previous(error, vnode, oldVNode, errorInfo);
    } catch (err) {
      // Let Suspense/lazy promises through untouched
      if (err && typeof err.then === 'function') throw err;
      console.error('[Preact] Uncaught component error', err);
    }
  };
}
